<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left  v-show="isVisibleLeft&&!isPlugin" :lang="lang.Left"></Left> -->
    <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle  :lang="lang.Middle"></Middle>
    <Right v-show="isVisibleRight" :lang="lang.Right"></Right>
 </div>
</template>

<script>
import Left from '@/components/PartManager/Views/PartTable/Left/Left'
import Middle from '@/components/PartManager/Views/PartTable/Middle/Middle'
import Right from '@/components/PartManager/Views/PartTable/Right/Right'
import { mapGetters } from 'vuex'

export default {
  name: 'PartTable',
  components:{
    Left,
    Middle,
    Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  computed:{
    ...mapGetters([
        'isPlugin',
       
      ]),
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  mounted () {
    //this.setCategory();
  },
  methods: {
    // setCategory(){
      
    //   if (this.routingData.from == "/Dashboard"){

    //     this.$store.dispatch("setElementCategory", this.routingData.parameters[0].category);

    //     for (var i = 0, le = this.$store.getters.categoryMapping.length; i < le; i++){
    //       //console.log(this.$store.getters.elementCategory +"=="+ this.$store.getters.categoryMapping[i].categoryName)
    //       if (this.$store.getters.elementCategory == this.$store.getters.categoryMapping[i].categoryName){
    //         var uid = this.$store.getters.categoryMapping[i].uid;
    //         this.$store.dispatch("selectTreeItem", uid)
    //       }else{
    //         //this.$store.dispatch("selectTreeItem", "/All")
    //       }
    //     }
    //   }




    // }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartTable.vue